module.exports = __webpack_public_path__ + "img/event-ete-oh-parc.850a7d4.jpg";